import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { createPinia } from 'pinia';

import App from './App.vue';

import router from '@/router';
import { ensureAdminRoutesFromStorage } from '@/router';
import print from 'vue3-print-nb';

import { getBuildVersion } from '@/utils/common';
import emitter from '@/utils/mitt';

import 'uno.css';
import '@/assets/main.css';
import '@/styles/index.scss';

import 'virtual:svg-icons-register';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/theme-chalk/el-message-box.css';
import 'element-plus/theme-chalk/el-loading.css';
import 'element-plus/theme-chalk/el-message.css';
import 'element-plus/theme-chalk/el-notification.css';

import { STORAGE_KEYS } from '@/utils/constants/storage';

// 主动检查版本更新
getBuildVersion()
    .then((version) => {
        if (version) {
            window.localStorage.setItem(STORAGE_KEYS.VERSION, version);
        }
    })
    .catch(() => {
        // 版本检查失败不影响应用正常运行
    });

let versionCheckInterval: ReturnType<typeof setInterval> | null = null;

function startVersionCheck() {
    if (versionCheckInterval) return;
    versionCheckInterval = setInterval(
        async () => {
            try {
                const currVersion = Number(window.localStorage.getItem(STORAGE_KEYS.VERSION));
                const lastVersion = await getBuildVersion();

                if (currVersion !== lastVersion) {
                    window.localStorage.setItem(STORAGE_KEYS.VERSION, lastVersion);
                    emitter.emit('showVersionDrawer', router.currentRoute.value.fullPath);
                }
            } catch {
                // 忽略版本检查异常，避免影响用户体验
            }
        },
        import.meta.env.PROD ? 30 * 1000 : 300 * 1000
    );
}

function stopVersionCheck() {
    if (versionCheckInterval) {
        clearInterval(versionCheckInterval);
        versionCheckInterval = null;
    }
}

// 页面可见时开启轮询，不可见时暂停以节省资源
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
        startVersionCheck();
    } else {
        stopVersionCheck();
    }
});

startVersionCheck();

const app = createApp(App);

/**
 * 注册Pinia
 */
app.use(createPinia());

/**
 * 注册element-plus UI
 */
app.use(ElementPlus, {
    locale: zhCn
});

/**
 * 注册element-plus Icons组件
 */
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

/**
 * 路由注册
 */
ensureAdminRoutesFromStorage();

app.use(router);
app.use(print);
app.mount('#app');
